<template>
  <div class="radio-wrapper">
    <RadioListItem :list="list" :selected="selected" :mobile="mobile" @change="change" />
  </div>
</template>

<script>
import RadioListItem from './RadioListItem';
export default {
  components: {
    RadioListItem
  },
  props: ['list', 'selected', 'mobile'],
  methods: {
    change (id) {
      this.$emit('change', id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .radio-wrapper {
    width: 100%;
  }
</style>
